import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import ContentPaste from "@mui/icons-material/ContentPaste";
import EditIcon from "@mui/icons-material/Edit";
import { useState } from "react";
import { Delete } from "@mui/icons-material";
import AddTaskTwoToneIcon from "@mui/icons-material/AddTaskTwoTone";
import { useGlobalContext } from "context/GlobalContext";
import { LinkRounded } from "@mui/icons-material";

export const ProductContextMenu = ({
  handleCopyAction1,
  copyLabel1,
  handleCopyAction2,
  copyLabel2,
  handleEditAction,
  editLabel,
  handleDeleteAction,
  deleteLabel,
  handleTaskAction,
  taskLabel,
  handleLinkClick,
  linkLabel,
  handleMiscAction1,
  misc1Label,
  handleEditExecutionTimeline,
  handleEditExecutionTimelineLabel,
  handleEditHandoverChecklistTimeline,
  handleEditHandoverChecklistTimelineLabel,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { unBoundMode } = useGlobalContext();

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
      >
        Action
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {handleCopyAction1 && unBoundMode && (
          <MenuItem onClick={handleCopyAction1}>
            <ListItemIcon>
              <ContentPaste fontSize="small" />
            </ListItemIcon>
            <ListItemText>{copyLabel1}</ListItemText>
          </MenuItem>
        )}
        {handleCopyAction2 && unBoundMode && (
          <MenuItem onClick={handleCopyAction2}>
            <ListItemIcon>
              <ContentPaste fontSize="small" />
            </ListItemIcon>
            <ListItemText>{copyLabel2}</ListItemText>
          </MenuItem>
        )}
        {handleEditAction && (
          <MenuItem onClick={handleEditAction}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{editLabel}</ListItemText>
          </MenuItem>
        )}
        {handleEditExecutionTimeline && (
          <MenuItem onClick={handleEditExecutionTimeline}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{handleEditExecutionTimelineLabel}</ListItemText>
          </MenuItem>
        )}
        {handleEditHandoverChecklistTimeline && (
          <MenuItem onClick={handleEditHandoverChecklistTimeline}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              {handleEditHandoverChecklistTimelineLabel}
            </ListItemText>
          </MenuItem>
        )}
        {handleDeleteAction && (
          <MenuItem onClick={handleDeleteAction}>
            <ListItemIcon>
              <Delete fontSize="small" />
            </ListItemIcon>
            <ListItemText>{deleteLabel}</ListItemText>
          </MenuItem>
        )}
        {handleTaskAction && (
          <MenuItem onClick={handleTaskAction}>
            <ListItemIcon>
              <AddTaskTwoToneIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{taskLabel}</ListItemText>
          </MenuItem>
        )}
        {handleMiscAction1 && (
          <MenuItem onClick={handleMiscAction1}>
            <ListItemText>{misc1Label}</ListItemText>
          </MenuItem>
        )}
        {handleLinkClick && (
          <MenuItem onClick={handleLinkClick}>
            <ListItemIcon>
              <LinkRounded fontSize="small" />
            </ListItemIcon>
            <ListItemText>{linkLabel}</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
